export default [
  {
    name: 'Pending Jobs',
    desc: 'List future jobs for Job Revamp',
    icon: 'exclamation-circle',
    permission: 'listJobs',
    submenu: [
      {
        name: 'Individual',
        link: '/jobs/list/single/pending',
        count: 'individual_pending'
      },
      {
        name: 'Recurring Base',
        link: '/jobs/list/recurring/pending',
        count: 'recurring_pending'
      }
    ]
  },
  {
    name: 'Individual Jobs',
    desc: 'List future jobs for Job Revamp',
    icon: 'right-circle',
    permission: 'listJobs',
    submenu: [
      {
        name: 'Future Jobs',
        link: '/jobs/list/single/future'
      },
      {
        name: 'Past Jobs',
        link: '/jobs/list/single/past'
      },
      {
        name: 'Cancelled Jobs',
        link: '/jobs/list/single/cancelled'
      }
    ]
  },
  {
    name: 'Recurring Base',
    desc: 'List future jobs for Job Revamp',
    icon: 'sync',
    permission: 'listJobs',
    submenu: [
      {
        name: 'Active Recurring Base',
        link: '/jobs/list/recurring/active'
      },
      {
        name: 'Ended Recurring Base',
        link: '/jobs/list/recurring/ended'
      }
    ]
  }
]
